var _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCooling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "10 2.63 10 5.37 10 17.37",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "8.31 .9 9.96 2.63 11.69 .9",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "11.69 19.1 10.04 17.37 8.31 19.1",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "17.37 10 14.63 10 2.63 10",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "19.1 8.31 17.37 9.96 19.1 11.69",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: ".9 11.69 2.63 10.04 .9 8.31",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "15.21 4.79 13.28 6.72 4.79 15.21",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "15.27 2.4 15.21 4.79 17.66 4.79",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "4.73 17.6 4.79 15.21 2.34 15.21",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    points: "4.79 4.79 6.72 6.72 15.21 15.21",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    points: "2.38 4.73 4.77 4.79 4.77 2.34",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    points: "17.6 15.27 15.21 15.21 15.21 17.66",
    fill: "none",
    stroke: "#2970ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCooling);
export default __webpack_public_path__ + "static/media/icon_cooling.edee5d6c3cf0c0de032bb83ff197afcd.svg";
export { ForwardRef as ReactComponent };